// Module
var code = " <gh-root-toolbar [options]=\"options\"></gh-root-toolbar> <div class=\"m-dialog-content\"> <ng-container #container=\"\"></ng-container> </div> ";
// Exports
module.exports = code;